import type { CommentFormAttachments } from '../../comment_form/comment_form';
import type { PendingAttachments } from '../hooks/use_pending_attachments';
import { getAttachmentTileItem } from './get_comment_form_attachments';

/** Adapts a form's pending attachments to what the comment form renders. */
export function getPendingFormAttachments(
  pending: PendingAttachments,
): CommentFormAttachments {
  const savedIds = new Set(
    pending.savedAttachments.map((attachment) => attachment.id),
  );
  return {
    items: [
      ...pending.savedAttachments.map(getAttachmentTileItem),
      ...pending.files.map((file) => ({
        id: file.localId,
        name: file.name,
        url: file.previewUrl,
        isUploading: pending.claimedIds.has(file.localId),
      })),
    ],
    hasAttachments: pending.hasAttachments,
    isUploading: pending.isUploading,
    onAdd: pending.addFiles,
    onRemove: (item) => {
      if (savedIds.has(item.id)) {
        pending.removeSaved(item.id);
      } else {
        pending.removeFile(item.id);
      }
    },
  };
}
